import AssociadoCadastroForm from 'forms/AssociadoCadastroForm/AssociadoCadastroForm';
import React from 'react';

function DadosBasicos({ data, handleUpdateData }) {
  return (
    <AssociadoCadastroForm
      initialValues={data}
      handleUpdateData={handleUpdateData}
    />
  );
}

export default DadosBasicos;
